export const formatToK = (num) => {
  if (num >= 1_000_000) {
    return `$${Math.floor((num / 1_000_000) * 10) / 10}M`;
  } else if (num >= 1_000) {
    return `$${Math.floor((num / 1_000) * 10) / 10}k`;
  } else {
    return `$${num.toFixed(2)}`;
  }
};